import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { isVoid } from '@/utils/common';

export default function LiquidChart({ title, value, format }) {
  const ref = useRef();
  const drawRef = useRef();
  const [isReady, setIsReady] = useState(false);

  const doInitDraw = useMemoizedFn(async () => {
    const { Liquid } = await import('@antv/g2plot');
    const config = {
      percent: 0.05,
      animation: {
        appear: {
          animation: 'fade-in', // 动画效果
          duration: 1000, // 动画执行时间
        },
      },
      radius: 0.8,
      statistic: {
        title: {
          formatter: () => title,
          style: ({ percent }) => ({
            fontSize: 12,
            fontWeight: 300,
            fill: percent > 0.65 ? 'white' : 'rgba(32, 43, 64, 0.5)',
          }),
        },
        content: {
          style: ({ percent }) => ({
            fontSize: 24,
            lineHeight: 1,
            fontWeight: 600,
            fill: percent > 0.65 ? 'white' : '#0D111A',
            textShadow: '.5px 0 white,0 0.5px white, -.5px 0 white, 0 -.5px white',
          }),
          content: '-',
        },
      },
      liquidStyle: {
        fill: 'rgba(51, 97, 255, 1)',
        stroke: 'rgba(51, 97, 255, 1)',
        lineWidth: 3,
        shadowColor: 'rgba(51, 97, 255, .5)',
        shadowBlur: 10,
        shadowOffsetX: -1,
        shadowOffsetY: 1,
      },
      color: 'rgba(51, 97, 255, 1)',
      wave: {
        length: 60,
      },
    };
    const liquid = new Liquid(ref.current, config);
    liquid.render();
    drawRef.current = liquid;
    setIsReady(true);
  });

  useEffect(() => {
    doInitDraw();
    return () => {
      drawRef.current?.destroy();
    };
  }, [doInitDraw]);

  useEffect(() => {
    if (isReady) {
      drawRef.current.update({
        percent: value > 0 ? 0.35 : 0.05,
        statistic: {
          title: {
            formatter: () => title,
          },
          content: {
            content: isVoid(value) ? '-' : format || String(value),
          },
        },
      });
    }
  }, [value, isReady, format, title]);

  return <Root ref={ref} />;
}

const Root = styled.div`
  width: 120px;
  height: 120px;
`;
